<template>
  <div class="flex w-full">
    <button
      v-for="(option, index) in options"
      :key="option.value"
      class="flex-1 p-3 text-center border disabled:opacity-60 button-group-selector-button"
      :class="getButtonClasses(option.value, index)"
      @click="handleClick(option.value)"
      :disabled="disabled"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script setup lang="ts">
interface ButtonGroupOption {
  value: string
  label: string
}

const props = withDefaults(
  defineProps<{
    options: ButtonGroupOption[]
    modelValue: string
    disabled?: boolean
  }>(),
  {
    disabled: false,
  },
)

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (e: 'update:modelValue', value: string): void
}>()

function handleClick(value: string): void {
  emit('update:modelValue', value)
}

function getButtonClasses(value: string, index: number): object {
  const isActive = props.modelValue === value
  const isFirst = index === 0
  const isLast = props.options.length > 0 && index === props.options.length - 1

  return {
    'text-button-guest-primary border-primary font-bold': isActive,
    'border-linear-g-primary': !isActive,
    'rounded-s': isFirst,
    'rounded-e': isLast,
    'border-r-0': isFirst && !isLast && !isActive,
    'border-l-0': isLast && !isFirst && !isActive,
  }
}
</script>
